import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/projects/Civi_Circle_Admin/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/projects/Civi_Circle_Admin/components/ui/input";
import { Label } from "@/projects/Civi_Circle_Admin/components/ui/label";
import { Textarea } from "@/projects/Civi_Circle_Admin/components/ui/textarea";
import { useToast } from "@/projects/Civi_Circle_Admin/hooks/use-toast";

interface EditCategoryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  category: any;
}

export function EditCategoryModal({
  open,
  onOpenChange,
  category,
}: EditCategoryModalProps) {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    await new Promise(resolve => setTimeout(resolve, 1000));

    toast({
      title: "Category Updated",
      description: "The volunteer category has been updated successfully.",
    });

    setLoading(false);
    onOpenChange(false);
  };

  if (!category) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Edit Category</DialogTitle>
          <DialogDescription>
            Update the category details, time slot, and capacity.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="space-y-2">
              <Label htmlFor="category-name">Category Name *</Label>
              <Input
                id="category-name"
                defaultValue={category.name}
                placeholder="e.g., Registration Desk"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="time-slot">Time Slot *</Label>
              <Input
                id="time-slot"
                defaultValue={category.timeSlot}
                placeholder="e.g., 8:00 AM - 10:00 AM"
                required
              />
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            <div className="space-y-2">
              <Label htmlFor="capacity">Capacity *</Label>
              <Input
                id="capacity"
                type="number"
                defaultValue={category.capacity}
                min="1"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="current">Current Volunteers</Label>
              <Input
                id="current"
                type="number"
                defaultValue={category.current}
                min="0"
                disabled
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="description">Description *</Label>
            <Textarea
              id="description"
              defaultValue={category.description}
              placeholder="Describe the role and responsibilities..."
              rows={3}
              required
            />
          </div>

          <DialogFooter className="gap-2 sm:gap-0">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Saving..." : "Save Changes"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
